/**
 * Multi-Drag Preview Store
 *
 * Module-level external store for sharing live drag deltas across all
 * selected clips so non-grabbed members of a multi-selection can render
 * the same transform during drag (before the snap-on-mouseup commit).
 *
 * Owned by the timeline editor only. Updated from drag handlers in
 * TimelineClip / TimelineAudioClip on mousedown / mousemove / mouseup,
 * and read via useSyncExternalStore by the same components.
 */

export interface MultiDragPreview {
  /** Clip the user grabbed. Other selected clips render the preview transform; this one renders its own local transform. */
  activeClipId: string
  /** Horizontal delta in pixels (relative to grab point). */
  deltaPx: number
  /** Vertical delta in pixels (relative to grab point). */
  deltaPxY: number
}

let current: MultiDragPreview | null = null
const listeners = new Set<() => void>()

export function getMultiDragPreview(): MultiDragPreview | null {
  return current
}

export function setMultiDragPreview(next: MultiDragPreview | null): void {
  if (current === next) return
  current = next
  for (const listener of listeners) listener()
}

export function subscribeMultiDragPreview(listener: () => void): () => void {
  listeners.add(listener)
  return () => {
    listeners.delete(listener)
  }
}
